<template>
  <path
    d="M18 2.00024H6C4.9 2.00024 4 2.90024 4 4.00024V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V4.00024C20 2.90024 19.1 2.00024 18 2.00024ZM6 4.00024H11V12.0002L8.5 10.5002L6 12.0002V4.00024ZM6.63 18.1902L8.62 15.6302C8.82 15.3802 9.2 15.3702 9.4 15.6202L11.14 17.7202L13.74 14.3802C13.94 14.1202 14.34 14.1202 14.53 14.3902L17.4 18.2102C17.65 18.5402 17.41 19.0102 17 19.0102H7.02C6.61 19.0002 6.37 18.5202 6.63 18.1902Z"
  />
</template>
